import { Video as LucideIcon, LogOut, User, ShieldAlert, Menu } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import { Button } from '../ui/Button';

interface UserTopbarProps {
  title: string;
  description?: string;
  action?: {
    label: string;
    icon: LucideIcon;
    onClick: () => void;
  };
  userName?: string;
  showImpersonation?: boolean;
  onStopImpersonation?: () => void;
  onMobileMenuOpen?: () => void;
}

export function UserTopbar({
  title,
  description,
  action,
  userName,
  showImpersonation,
  onStopImpersonation,
  onMobileMenuOpen,
}: UserTopbarProps) {
  const { signOut } = useAuth();

  return (
    <>
      {showImpersonation && (
        <div className="bg-orange-500 text-white px-4 py-3">
          <div className="max-w-7xl mx-auto flex items-center justify-between">
            <div className="flex items-center gap-3">
              <ShieldAlert size={24} />
              <div>
                <div className="font-semibold">Mode administrateur actif</div>
                <div className="text-sm text-orange-100">Vous consultez l'espace d'un utilisateur</div>
              </div>
            </div>
            <Button
              onClick={onStopImpersonation}
              variant="outline"
              size="sm"
              className="!bg-white !text-orange-600 border-0 hover:!bg-orange-50"
            >
              Retour admin
            </Button>
          </div>
        </div>
      )}

      <div className="sticky top-0 z-20 bg-white border-b border-gray-200">
        <div className="px-4 md:px-6 py-4">
          <div className="flex items-center justify-between gap-3">
            <div className="flex items-center gap-3 min-w-0">
              <button
                onClick={onMobileMenuOpen}
                className="md:hidden p-2 rounded-lg text-gray-500 hover:bg-gray-100 transition-colors flex-shrink-0"
                aria-label="Ouvrir le menu"
              >
                <Menu size={22} />
              </button>
              <div className="min-w-0">
                <h1 className="text-xl md:text-2xl font-bold text-gray-900 truncate">{title}</h1>
                {description && (
                  <p className="mt-1 text-sm text-gray-600 hidden sm:block">{description}</p>
                )}
              </div>
            </div>

            <div className="flex items-center gap-2 md:gap-3 flex-shrink-0">
              {action && (
                <Button
                  onClick={action.onClick}
                  variant="primary"
                  size="md"
                >
                  <action.icon size={18} />
                  <span className="hidden sm:inline">{action.label}</span>
                </Button>
              )}

              {userName && (
                <div className="hidden md:flex items-center gap-2 px-3 py-2 bg-gray-50 rounded-lg">
                  <User size={18} className="text-gray-600" />
                  <span className="text-sm font-medium text-gray-700">
                    Bonjour {userName}
                  </span>
                </div>
              )}

              <Button
                onClick={signOut}
                variant="ghost"
                size="md"
              >
                <LogOut size={18} />
                <span className="hidden sm:inline">Déconnexion</span>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
